var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base" },
    [
      _c(
        "v-card",
        { attrs: { tile: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "flex-grow-0", attrs: { flat: "" } },
            [
              _c("v-toolbar-title", { staticClass: "pl-3" }, [
                _vm._v("Выгрузка закупки"),
              ]),
              _c("v-spacer"),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.base.hide()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            [
              _c(
                "v-row",
                {
                  staticStyle: { height: "240px" },
                  attrs: {
                    "no-gutters": "",
                    justify: "center",
                    align: "center",
                  },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "auto" } },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          size: "90",
                          width: "3",
                          color: "dark",
                        },
                      }),
                      _c("div", { staticClass: "mt-12 primary--text" }, [
                        _vm._v(" Подготавливаем файл для скачивания."),
                        _c("br"),
                        _vm._v(" Пожалуйста, подождите... "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }